import React from 'react'
import Container from './style'
import Spinner from '../Spinner'

const Button = ({
  disabled = false,
  loading = false,
  primary = true,
  secondary,
  tertiary,
  full,
  style,
  small,
  type = 'button',
  className,
  rounded,
  icon,
  iconRight,
  iconLeft,
  bordered,
  spinnerWithTxt = false,
  hasShadow,
  onClick,
  children,
  ...rest
}) => {
  // Filter out custom props that shouldn't be passed to DOM
  const { ...domProps } = rest;
  
  return (
    <Container
      className={`btn u--typo__btn ${loading ? 'loading--btn' : ''} ${
        className ? className : ''
      }`}
      $icon={icon}
      $iconRight={iconRight}
      $spinnerWithTxt={spinnerWithTxt}
      $iconLeft={iconLeft}
      disabled={disabled || loading}
      $primary={primary}
      $secondary={secondary}
      $tertiary={tertiary}
      $rounded={rounded}
      $full={full}
      $small={small}
      onClick={onClick}
      type={type}
      style={style}
      {...domProps}
    >
      {spinnerWithTxt ? (
        <>
          {loading && <Spinner size={'1.2rem'} />} {children}
        </>
      ) : (
        <>{loading ? <Spinner size={'1rem'} /> : children}</>
      )}
    </Container>
  )
}
export default Button
